import { useQuery } from '@tanstack/react-query';

import { fetchPatientInfoByUserId } from '@/shared/api/lotus';

import { userInfoKeys } from './keys';

export function userInfoQueryDefinition(userId: string) {
  return {
    queryKey: userInfoKeys.byUser(userId),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchPatientInfoByUserId(userId, signal),
    meta: {
      toast: {
        title: 'Could not load patient info',
        description: 'Patient info could not be fetched.',
      },
    },
  } as const;
}

/**
 * Fetch Patient Info for a user via React Query.
 */
export function useUserInfoQuery(userId: string | undefined) {
  return useQuery({
    ...userInfoQueryDefinition(userId ?? ''),
    enabled: !!userId,
  });
}
